// @flow

import { Component } from '../jsti/core';
import { isOverflown, isSmallScreen, outerHeight } from '../classes/Helpers';
import Notifications from '../constants/Notifications';

export default class CartNotificationMain extends Component {
  /**
   * Initiate the component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);

    this.addListener(Notifications.CART_UPDATE_DATA, this.onCartUpdate);
    this.onCartUpdate();
  }

  /**
   * Executes when the cart is updated
   *
   * TODO: Remove setTimeout and listen to a notification
   * Could not do this, because CartItems sends 2 notifications on the cart page with different results
   * This is because the cart page has 2 CartItems components
   */
  onCartUpdate(): void {
    setTimeout(() => {
      this.setHeight();

      if (isOverflown(this.el)) {
        this.addInnerScrollbar();
      } else {
        this.hideInnerScrollbar();
      }
    }, 0);
  }

  /**
   * Adds an inner scroll bar so products can be scrolled
   */
  addInnerScrollbar(): void {
    this.el.classList.add('overflown');
  }

  /**
   * Hides the inner scroll bar so products can't be scrolled anymore
   */
  hideInnerScrollbar(): void {
    this.el.classList.remove('overflown');
  }

  /**
   * Set the height of the component
   */
  setHeight(): void {
    if (isSmallScreen()) return;

    const notification: ?HTMLElement = document.getElementById('cart-notification');
    if (!notification) return;

    const headerHeight = outerHeight(notification.querySelector('header'));
    const footerHeight = outerHeight(notification.querySelector('footer'));

    const alertHeight = outerHeight(document.getElementByRef('alerts'));

    const mainHeight = window.innerHeight - (headerHeight + footerHeight + alertHeight);
    this.el.style.height = `${mainHeight}px`;
  }
}
